import { remoteValues } from '~/common/utils/firebase/remoteConfig';

export type TemplateKey = 'concluido_sem_anexo' | 'concluido_com_anexo' | 'pendente_sem_anexo' | 'pendente_com_anexo';

export const PLACEHOLDER_TOKEN = '[comentário do agente aqui]';

export const FALLBACK_TEMPLATES: Record<TemplateKey, string> = {
  concluido_sem_anexo:
    'Olá, [nome do cliente]!\n\nSeu ticket #[ticketid] foi concluído.\n\n[comentário do agente aqui]\n\nQualquer dúvida, é só responder esta mensagem.',
  concluido_com_anexo:
    'Olá, [nome do cliente]!\n\nSeu ticket #[ticketid] foi concluído.\n\n[comentário do agente aqui]\n\nSegue em anexo a documentação referente ao encerramento do atendimento.\n\nQualquer dúvida, é só responder esta mensagem.',
  pendente_sem_anexo:
    'Olá, [nome do cliente]!\n\nSeu ticket #[ticketid] requer sua atenção.\n\n[comentário do agente aqui]\n\nQualquer dúvida, é só responder esta mensagem.',
  pendente_com_anexo:
    'Olá, [nome do cliente]!\n\nSeu ticket #[ticketid] requer sua atenção.\n\n[comentário do agente aqui]\n\nSegue em anexo a documentação mencionada. Por favor, verifique e nos retorne assim que possível.\n\nQualquer dúvida, é só responder esta mensagem.',
};

export function normalizeStatusName(value: string): string {
  return value.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

export function isFlow2Status(statusName: string): boolean {
  const normalized = normalizeStatusName(statusName);
  return normalized === 'concluido' || normalized === 'pendente cliente';
}

export function getTemplates(): Record<TemplateKey, string> {
  try {
    const rcValue = (remoteValues as any)?.whatsapp_resolve_templates;
    if (rcValue) {
      const parsed = JSON.parse(rcValue);
      const requiredKeys: TemplateKey[] = [
        'concluido_sem_anexo',
        'concluido_com_anexo',
        'pendente_sem_anexo',
        'pendente_com_anexo',
      ];
      if (requiredKeys.every((k) => k in parsed)) {
        return parsed;
      }
    }
  } catch {
    // fall through to defaults
  }
  return FALLBACK_TEMPLATES;
}

export function selectTemplate(normalizedStatusName: string, hasFiles: boolean): string {
  const templates = getTemplates();
  const isConcluido = normalizedStatusName === 'concluido';

  if (isConcluido && !hasFiles) return templates.concluido_sem_anexo;
  if (isConcluido && hasFiles) return templates.concluido_com_anexo;
  if (!isConcluido && !hasFiles) return templates.pendente_sem_anexo;
  return templates.pendente_com_anexo;
}

export function interpolateTemplate(
  template: string,
  vars: { clientName: string; ticketId: string; agentComment: string },
): string {
  return template
    .replace('[nome do cliente]', vars.clientName || '[nome do cliente]')
    .replace('[ticketid]', String(vars.ticketId || '[ticketid]'))
    .replace(PLACEHOLDER_TOKEN, vars.agentComment || PLACEHOLDER_TOKEN);
}

export function interpolateStaticVars(template: string, vars: { clientName: string; ticketId: string }): string {
  return template
    .replace('[nome do cliente]', vars.clientName || '[nome do cliente]')
    .replace('[ticketid]', String(vars.ticketId || '[ticketid]'));
}
